import { Button } from "@elaniintc/goes-design-system";
import type { TagType } from "@/types/entities/tags";

interface NewTagModalFooterProps {
  isEditing: boolean;
  isPending: boolean;
  isValid: boolean;
  editData?: TagType;
  handleDelete: () => void;
  handleClose: () => void;
}

export const NewTagModalFooter = ({
  isEditing,
  isPending,
  isValid,
  editData,
  handleDelete,
  handleClose,
}: NewTagModalFooterProps) => {
  return (
    <div className="w-full py-3 px-8">
      {isEditing ? (
        <div className="w-full flex items-center justify-between gap-3">
          <div className="flex gap-3">
            <Button
              size="sm"
              type="button"
              variant="danger-tertiary"
              onClick={handleDelete}
              disabled={
                isPending ||
                Boolean(
                  editData?.processes_count && editData.processes_count > 0,
                )
              }
              className="min-w-30 cursor-pointer"
            >
              Eliminar
            </Button>
          </div>

          {/* Botones Cancelar y Guardar alineados a la derecha */}
          <div className="flex gap-3">
            <Button
              variant="tertiary"
              size="sm"
              type="button"
              onClick={handleClose}
              disabled={isPending}
              className="min-w-30 cursor-pointer"
            >
              Cancelar
            </Button>
            <Button
              variant="default"
              size="sm"
              type="submit"
              className="min-w-35 cursor-pointer disabled:bg-neutral-object-accent disabled:text-on-disabled disabled:border-none disabled:shadow-none"
              disabled={!isValid || isPending}
              form="tag-form"
            >
              {isPending ? "Actualizando..." : "Guardar cambios"}
            </Button>
          </div>
        </div>
      ) : (
        <div className="w-full grid grid-cols-1 tablet:grid-cols-2 gap-3">
          <Button
            variant="tertiary"
            size="sm"
            type="button"
            onClick={handleClose}
            disabled={isPending}
            className="min-w-30 cursor-pointer"
          >
            Cancelar
          </Button>
          <Button
            variant="default"
            size="sm"
            type="submit"
            className="min-w-35 cursor-pointer disabled:bg-neutral-object-accent disabled:text-on-disabled disabled:border-none disabled:shadow-none"
            disabled={!isValid || isPending}
            form="tag-form"
          >
            {isPending ? "Creando..." : "Crear etiqueta"}
          </Button>
        </div>
      )}
    </div>
  );
};
